<template>
    <div class="div" style="background-color: white;">
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <!-- border: 5px solid #623e7e; -->
        <div class="container" style="background-color: white;" flat v-if="leraner_marksheet != ''">
            <div class="row">
                <div class="col-3">
                    <img class="pl-5" src="@/assets/img_start_1.png" alt="" width="200px" height="200px" />
                </div>
                <div class="col-6 pt-8">
                    <div class="row">
                        <div class="col-2 pt-12">
                            <img class="pl-1" src="https://eduplusschool.s3.ap-south-1.amazonaws.com/logo/WWS_Logo-01.png"
                                width="80px" height="80px" alt="logo" />
                        </div>
                        <div class="col-10 pt-12" style="padding-left: 2rem;">
                            <span
                                style="border-bottom-width: thin; border-bottom-style: outset;font-weight:bolder; font-size: 35px;">
                                Wisdom World School
                            </span><br>
                            <span style="text-transform: uppercase;font-size: 18px;"> {{ org_basic_data.address }}</span>
                        </div>
                    </div>
                </div>
                <div class="col-3">
                    <img src="@/assets/img_start_2.png" alt="" width="200px" height="200px" />
                </div>
            </div>
            <center>
                <span style="font-weight: bold; font-size: larger;line-height: 2;">
                    <strong>
                        <center> <span style="text-transform: uppercase;">{{ standard }}</span> REPORT CARD {{ ay }} <br>
                            {{ semester }}
                        </center>
                    </strong>
                </span>
            </center>
            <v-col cols="12" sm="12" md="12" class="margin_result">
                <center>
                    <table style="width: 80%;">
                        <thead class="pt-5 mt-5">
                            <th style="text-align:left;" class="pl-2" v-if="name_as_on_aadhar_card != '' && name_as_on_aadhar_card != null">NAME: {{ name_as_on_aadhar_card }}</th>
                            <th style="text-align:left;" class="pl-2" v-else>NAME: {{ first_last_name }}</th>

                            <th style="text-align:left;" class="pl-2">DIVISION: {{ div }}</th>

                        </thead>
                    </table>
                </center>
            </v-col>
            <span v-for="s in leraner_marksheet.leraner_marksheet" :key="s.c_id">
                <v-col cols="12" sm="12" md="12">
                    <div class="table-breaked">
                        <span v-if="s.crs_image_list != ''" class="image">
                            <!-- {{ s.crs_image_list }} -->
                            <v-row class="mb-1 pb-1">
                                <v-col cols="12" sm="6" md="6" v-for="ci, index in s.crs_image_list" :key="index">
                                    <img :src="ci.file" v-if="index === 0" style="float: left;" width="80px" height="80px"
                                        alt="logo" class="ci-image" />
                                    <img :src="ci.file" v-else style="float: right;" width="80px" height="80px" alt="logo"
                                        class="ci-image" />
                                </v-col>
                            </v-row>
                        </span>
                        <v-simple-table flat dense>

                            <thead>

                                <tr>
                                    <th class="crs_name" style="text-transform: uppercase; font-size: 16px; font-weight: bold;color: black;">
                                        <strong>{{ s.crs_name }}</strong>
                                    </th>
                                    <th style="width:140px"
                                        v-for="header in leraner_marksheet.grading_scheme_details_for_marksheet"
                                        :key="header">
                                        <center style="font-size: 16px; font-weight: bold;color: black;"><strong>{{
                                            header.gradename
                                        }}</strong></center>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(header, index) in s.rubric_header " :key="index">
                                    <td v-if="header.rubric" class="fixed-width-rubric">{{ header.rubric }}</td>
                                    <td v-for="(g, index) in header.grade" :key="index">
                                        <center>
                                            <img v-if="g != ''" :src="g" style="width: 50%; height: 43px;" alt="logo"
                                                class="pt-2" />
                                            <span v-else style="width: 50%; height: 43px;">
                                                {{ g }}
                                            </span>
                                        </center>
                                    </td>
                                </tr>
                            </tbody>
                            <!-- <span v-if="s.crs_image_list != ''" class="image">
                               
                                <v-row class="mt-5 pt-5">
                                    <v-col cols="12" sm="6" md="6" v-for="ci, index in s.crs_image_list" :key="index">
                                        <img :src="ci.file" width="140px" height="140px" alt="logo" class="ci-image" />
                                    </v-col>
                                </v-row>
                            </span> -->
                        </v-simple-table>
                    </div>
                </v-col>
            </span>
            <br>
            <v-col cols="12" sm="12" md="12" class="margin_here_del">
                <center>
                    <table style="width: 80%;">
                        <thead class="pt-5 mt-5">
                            <th style="text-align:left;width:50%" class="pl-2">ATTENDANCE</th>
                            <th>{{ leraner_marksheet.sem_attendance[0].present }}/{{
                                leraner_marksheet.sem_attendance[0].total_working_stud }} </th>
                        </thead>
                    </table>
                </center>
            </v-col>
            <v-col cols="12" sm="12" md="12" class="margin_here_del">
                <center>
                    <table style="width: 80%;">
                        <thead class="pt-5 mt-5">
                            <th style="text-align:left;width:50%" class="pl-2">CLASS TEACHER’S NAME</th>
                            <th>{{ inst_name }}</th>
                        </thead>
                    </table>
                </center>
            </v-col>
            <v-col cols="12" sm="12" md="12">
                <strong style="font-size: 14px;">
                    <center>
                        Disclaimer- For official and legal purposes this Report Card will need to be authenticated and
                        countersigned by the school authorities. </center>
                </strong>
            </v-col>
            <div class="row page_01">
                <div class="col-3">
                    <img class="pl-5 pageNo" src="@/assets/img_end_1.png" alt="" width="150px" height="150px" />
                </div>
                <div class="col-6 pt-8">
                    <div class="row">

                    </div>
                </div>
                <div class="col-3">
                    <img class="pageNo" src="@/assets/img_end_2.png" alt="" width="150px" height="150px" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
    props: {
        org: Number,
    },
    data() {
        return {
            inst_name: null,
            dialog_marks: false,
            overlay: false,
            selected: [],
            snackbar: false,
            search: "",
            snackbar_msg: "",
            color: "",
            snackbar: false,
            ay_std_div_list: null,
            sel_ay_data: null,
            semester_list: null,
            sem: null,
            fetch_loader: false,
            show: false,
            course_list: [],
            stud_list: [],
            awspath: "",
            registration_no: null,
            standard: null,
            semester: null,
            div: null,
            ay: null,
            name: null,
            name_as_on_aadhar_card: null,
            first_last_name: null,
            dob: null,
            roll_no: null,
            mobile_no: null,
            address: null,
            mother_name: null,
            photo: null,
            reg_no: null,
            gr_no: null,
            father_full_name: null,
            leraner_marksheet: [],
            semester: null,
            colspan: null,
            overall_grade: null,
            remark: [],
            grading_scheme_details_for_marksheet: [],
            org_basic_data: []
        };
    },

    methods: {

        print() {
            this.$store.state.drawer = false;
            let that = this;
            window.onafterprint = function () {
                that.$store.state.drawer = true;
            };
            setTimeout(function () {
                window.print();
            }, 100);
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
        onload() {
            const data = {
                lid: this.registration_no,
                ay: this.sel_ay_data,
                sem: this.sem,
                org: this.org,
            };
            axios
                .post("/WWSExamination/getLearnerMarksheetPrePrim", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.standard = res.data.standard;
                        this.semester = res.data.semester
                        this.div = res.data.div;
                        this.ay = res.data.ay;
                        this.name = res.data.name;
                        this.name_as_on_aadhar_card = res.data.name_as_on_aadhar_card
                        this.first_last_name = res.data.first_last_name
                        this.dob = res.data.dob;
                        this.roll_no = res.data.roll_no;
                        this.mobile_no = res.data.mobile_no;
                        this.address = res.data.address;
                        this.mother_name = res.data.mother_name;
                        this.photo = res.data.photo;
                        this.reg_no = res.data.reg_no;
                        this.gr_no = res.data.gr_no;
                        this.father_full_name = res.data.father_full_name;
                        this.leraner_marksheet = res.data.leraner_marksheet;
                        this.semester = res.data.semester;
                        this.inst_name = res.data.inst_name;
                        this.org_basic_data = res.data.org_basic_data
                    }
                    if (res.data.flag == "NO") {
                        this.showSnackbar("#b71c1c", res.data.fmsg); // show snackbar
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                })
                .finally(() => { });
        },
    },
    mounted() {
        this.awspath = localStorage.getItem("awspath");
        this.sel_ay_data = localStorage.getItem("setay");
        this.sem = localStorage.getItem("setsem");
        this.registration_no = localStorage.getItem("setreg_no");
        this.onload();
    },
};
</script>
<style scoped>
.image {
    overflow: hidden;
    display: flex;
    /* justify-content: flex-end; */
}

.ci-image {
    margin: 0;
    padding: 0;
    /* margin-left: 20px;
    margin-top: 0; */
    /* justify-content: flex-end; */
    display: block;
}



.fixed-width-rubric {
    width: 350px;
}

table,
th,
td {
    font-size: 17px;
    border: 2px solid black;
    border-collapse: collapse;
}

.th {
    border: 1px solid black;
    border-bottom: 1px solid black;
    font-size: 17px;
}

@media print {
    .card {
        border: none !important;
        font-size: large !important;
    }

    .pagebreak {
        page-break-before: always;
    }

    header,
    footer,
    nav,
    date {
        display: none !important;
    }

    table,
    td,
    tr {
        break-inside: avoid-page;
    }

    body,
    tr,
    th,
    td {
        font-size: large !important;
    }

    .no-display,
    .v-input__control,
    input[type="button"],
    input[type="submit"],
    input[type="reset"],
    #v-card {
        display: none !important;
    }

    v-card {
        border: none !important;
    }

    @page {
        size: A4;
        margin-top: none;
        padding-top: none;
        size: 270mm 390mm;
    }
    .crs_name{
        width:410px
    } 
    .table-breaked {
        page-break-inside: avoid;
        margin-top: 1rem;
    }

    .div::before {
        content: "";
        position: fixed;
        top: 0px;
        left: 0;
        width: 100%;
        height: 100%;
        border: 5px solid #623e7e !important;
        /* Add a 1px solid black border to each page */
    }

    thead {
        font-weight: bold !important;
    }

    /* .margin_result {
        margin-bottom: 5%;
        margin-top: 5%;
    } */
    .margin_here {
        margin-bottom: 5%;
        margin-top: 5%;
    }

    .page_01 {
        position: relative !important;
    }

    .pageNo {
        position: absolute;
    }

    /* .pageNo img{
        bottom: 0;
        text-align: center;
        font-size: 22px;
        width: 100%;
        visibility: visible !important;
      }*/
}
</style>

